import React, { useState } from 'react';
import { ChevronDown, FileSpreadsheet, Loader2, SlidersHorizontal } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/DropdownMenu';
import { ExportDialog } from './ExportDialog';
import { useStudents } from '../../contexts/StudentsContext';
import { exportStudentsToExcel } from '../../utils/excel';
export function ExportMenu({
  variant = 'compact'
}: {
  variant?: 'compact' | 'full';
}) {
  const {
    students
  } = useStudents();
  const [exporting, setExporting] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const exportAll = async () => {
    if (students.length === 0) {
      toast.warning('There are no records in Supabase to export yet.');
      return;
    }
    setExporting(true);
    // Let the spinner paint before the synchronous workbook build.
    await new Promise(resolve => setTimeout(resolve, 220));
    try {
      const fileName = exportStudentsToExcel(students, {
        scope: 'all',
        className: '',
        gender: ''
      });
      toast.success(`Exported ${students.length} record${students.length === 1 ? '' : 's'}`, {
        description: fileName
      });
    } catch (error) {
      toast.error('Excel export failed', {
        description: error instanceof Error ? error.message : 'Unknown error'
      });
    } finally {
      setExporting(false);
    }
  };
  return <>
      <DropdownMenu data-id="element-134" data-mp="20492vvsuuboc">
        <DropdownMenuTrigger asChild data-id="element-135" data-mp="205sjjnifaoqn">
          <Button variant="outline" disabled={exporting} className={`h-9 rounded-xl border-[var(--glass-hairline)] bg-white/60 px-3 font-medium text-foreground hover:bg-white/80 dark:bg-white/5 dark:hover:bg-white/10 ${variant === 'compact' ? '' : 'w-full justify-between'}`} data-id="element-136" data-mp="206u4qkt5krm3">
            {exporting ? <Loader2 className="h-4 w-4 animate-spin text-emerald-600" data-id="element-137" data-mp="3lkgh43005th3" /> : <FileSpreadsheet className="h-4 w-4 text-emerald-600" data-id="element-138" data-mp="2vsdgiebq7bgs" />}
            <span className={variant === 'compact' ? 'ml-2 hidden sm:inline' : 'ml-2'} data-id="element-139" data-mp="2qubzs01rvo8h">
              {exporting ? 'Preparing…' : 'Download Excel Report'}
            </span>
            <ChevronDown className="ml-1.5 h-3.5 w-3.5 opacity-60" data-id="element-140" data-mp="30t1fbm674wlk" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64" data-id="element-141" data-mp="2d4i879yvupv2">
          <DropdownMenuLabel data-id="element-142" data-mp="284vukzf577lq">Excel report</DropdownMenuLabel>
          <DropdownMenuSeparator data-id="element-143" data-mp="286gqasd70wl6" />
          <DropdownMenuItem onClick={exportAll} data-id="element-144" data-mp="2mtjpd3h5zdam">
            <FileSpreadsheet className="mr-2 h-4 w-4" data-id="element-145" data-mp="2mv33ooj9fe9r" />
            Export all students
            <span className="ml-auto font-mono text-xs text-muted-foreground" data-id="element-146" data-mp="2i1s3h68ydvqt">{students.length}</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setConfigOpen(true)} data-id="element-147" data-mp="1ub4jvnpodhof">
            <SlidersHorizontal className="mr-2 h-4 w-4" data-id="element-148" data-mp="1pd34bcrgk0hp" />
            Custom export…
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ExportDialog open={configOpen} onOpenChange={setConfigOpen} data-id="element-149" data-mp="9mk00xfrarqb" />
    </>;
}